// removed by extract-text-webpack-plugin
module.exports = {"goodIn":"wmf-1YQ6_1CV","search":"wmf-1x4QGoxM","goodBody":"wmf-39jJlC24","publicspan":"wmf-PvPxMg25","page":"wmf-3z3arLNv"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/salesreport/salesstatisticsreport/salesstatisticsreport.module.less
// module id = 3898
// module chunks = 0